import React from 'react';

import { useTranslation } from '@/hooks/useTranslation';
import { cn } from '@/services/utils';

import { Badge } from '../Badge';

type LabelPanelProps = {
    icon?: React.ElementType;
    titleOne: string;
    titleTwo?: string;
    titleOneHasMaxWidth?: boolean;
    backgroundClassName?: string;
    /** Overrides the default `tw-text-t-primary` tone on the icon and titles. */
    textClassName?: string;
    noPadding?: boolean;
    badgeTitle?:string;
    variant?: 'info' | 'success' | 'error' | 'warning' | 'neutral',
};

const LabelPanel: React.FC<LabelPanelProps> = ({
    icon: Icon,
    titleOne,
    titleTwo,
    titleOneHasMaxWidth = false,
    backgroundClassName,
    textClassName,
    noPadding,
    badgeTitle,
    variant= 'info'
}) => {
    const { t } = useTranslation();
    const toneClassName = textClassName ?? 'tw-text-t-primary';
    return (
        <div className={cn('tw-inline-flex tw-items-center tw-gap-2 tw-bg-gray-100 tw-rounded',
            !noPadding && 'tw-px-3 tw-py-2',
            backgroundClassName
        )}>
            <div
                className={cn(
                    'tw-inline-flex tw-items-center tw-justify-center tw-gap-1',
                    'smaller:tw-inline-flex sm:tw-justify-center smaller:tw-items-center',
                    'tw-text-t-sm',
                    'font-dynamic',
                    'lg-font-dynamic',
                )}
            >
                {Icon && (
                    <Icon
                        aria-hidden="true"
                        className={cn('tw-gap-1 tw-w-5 tw-h-5 lg-icon-dynamic', toneClassName)}
                    />
                )}
                <div
                    title={titleOne}
                    className={cn(
                        'tw-truncate tw-overflow-hidden tw-whitespace-nowrap',
                        toneClassName,
                        titleOneHasMaxWidth && 'width-fix lg-width-fix',
                    )}
                >
                    {titleOne}
                </div>
                {titleTwo && (
                    <span className={cn('tw-whitespace-nowrap tw-flex-shrink-0', toneClassName)}>{titleTwo}</span>
                )}
            </div>
            {  badgeTitle &&
                <Badge type='status' variant={ variant } >{t(badgeTitle)}</Badge>
            }
        </div>

    );
};

export default LabelPanel;
